/**
 * Stable e2e hooks for staff lists. Prefix is `staff-list-`.
 * Add a data-testid here whenever a redesign adds a control.
 *
 * type      — Filters > Type (Customer / Supplier / Archive / Back Order / Reorder)
 * orderType — table column filter for order type codes (R, …); column is hidden by default
 */
export const STAFF_LIST_TEST_IDS = {
  page: 'staff-list-page',
  loader: 'staff-list-loader',
  filters: 'staff-list-filters',
  filtersToggle: 'staff-list-filters-toggle',
  resetFilters: 'staff-list-reset-filters',
  import: 'staff-list-import',
  importMenu: 'staff-list-import-menu',
  export: 'staff-list-export',
  newItem: 'staff-list-new',
  type: 'staff-list-type',
  orderType: 'staff-list-col-filter-type',
  people: 'staff-list-people',
  sales: 'staff-list-sales',
  reorderDate: 'staff-list-reorder-date',
  scopeInvoiced: 'staff-list-scope-invoiced',
  scopeArchived: 'staff-list-scope-archived',
  scopeVas: 'staff-list-scope-vas',
  scopeActionable: 'staff-list-scope-actionable',
  scopeCancelled: 'staff-list-scope-cancelled',
  vasType: 'staff-list-vas-type',
  refresh: 'staff-list-refresh',
  columns: 'staff-list-columns',
  columnPicker: 'staff-list-column-picker',
  restoreColumns: 'staff-list-restore-columns',
  colFilters: 'staff-list-col-filters',
  clearColFilters: 'staff-list-clear-col-filters',
  filtersActive: 'staff-list-filters-active',
  table: 'staff-list-table',
  rowActions: 'staff-list-row-actions',
  bulk: 'staff-list-bulk',
  rowsPerPage: 'staff-list-rows-per-page',
  pageFirst: 'staff-list-page-first',
  pagePrev: 'staff-list-page-prev',
  pageNext: 'staff-list-page-next',
  pageLast: 'staff-list-page-last',
  colFilter: (key) => `staff-list-col-filter-${key}`,
  containerTabs: 'staff-list-container-tabs',
  containerTab: (viewType) => `staff-list-container-tab-${viewType}`,
  shipmentTracking: 'staff-list-shipment-tracking',
};
